var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLanguageIcon = function SvgLanguageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5344C1",
    stroke: "#5344C1",
    d: "m8.644 17.01 1.252 6.26a.282.282 0 0 0 .42.19l3.462-6.175.04-.069.057-.053a.283.283 0 0 0-.192-.491H8.921a.28.28 0 0 0-.219.104zm0 0a.28.28 0 0 1 .058-.234z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5344C1",
    d: "M12.735 16.675h.606l-.115-.596-1.74-8.981a.282.282 0 0 1 .277-.336h9.889a1.85 1.85 0 0 1 1.847 1.848v13.043a1.85 1.85 0 0 1-1.847 1.848H10.159a.28.28 0 0 1-.263-.228l-1.252-6.26a.282.282 0 0 1 .277-.338zm-4.581.436Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5344C1",
    fillRule: "evenodd",
    d: "M21.29 10.844v1.29h-1.243v6.651H18.38v-2.793a1.8 1.8 0 0 1-.533.083c-.213 0-.402-.047-.58-.118v.07c0 1.338-1.006 2.32-2.615 2.32-1.55 0-2.355-.84-2.651-1.278l1.148-1.053c.248.438.757.947 1.527.947.627 0 .994-.379.994-.9 0-.509-.367-.816-1.125-.816h-.639v-1.385h.415c.721 0 1.017-.379 1.017-.911 0-.462-.32-.781-.828-.781-.473 0-.793.225-1.018.591l-1.041-.982c.378-.544 1.124-.994 2.106-.994 1.385 0 2.308.793 2.308 2 0 .675-.308 1.255-.864 1.527v.047c.13.024.272.071.402.142h.012c.024.024.047.036.071.048.32.165.651.236.947.236.414 0 .722-.083.947-.201v-2.45h-.923v-1.29z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5344C1",
    d: "M13.684 17.739H2.348A2.35 2.35 0 0 1 0 15.39V2.348A2.35 2.35 0 0 1 2.348 0h8.205c.375 0 .697.266.768.634l3.13 16.173a.782.782 0 0 1-.768.932"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.81 10.715H4.92l-.55 1.648H2.617l2.978-8h1.528l2.994 8H8.364zM5.363 9.38h2L6.36 6.385z",
    clipRule: "evenodd"
  })));
};
export default SvgLanguageIcon;